import React from 'react';
import type ProjectSettingsServiceDeskExternalLinksType from '@atlassian/jira-spa-apps-project-settings-service-desk-external-links/src/index.tsx';
import { markAsProductBundleReady } from '@atlassian/jira-spa/src/services/mark-as-product-bundle-ready/index.tsx';
import { LazyPage } from '@atlassian/jira-spa/src/view/lazy-page/index.tsx';
import { lazyForPaint } from '@atlassian/react-loosely-lazy';

export const LazyProjectSettingsServiceDeskExternalLinks = lazyForPaint<
	typeof ProjectSettingsServiceDeskExternalLinksType
>(
	() =>
		markAsProductBundleReady(
			import(
				/* webpackChunkName: "async-project-settings-service-desk-external-links", jiraSpaEntry: "async-project-settings-service-desk-external-links" */ '@atlassian/jira-spa-apps-project-settings-service-desk-external-links'
			),
		),
	{ entryFsSsrOverride: 'exclude' },
);

const AsyncProjectSettingsServiceDeskExternalLinks = (): React.JSX.Element => (
	<LazyPage
		Page={LazyProjectSettingsServiceDeskExternalLinks}
		pageId="project-settings-external-links"
		shouldShowSpinner
	/>
);

export default AsyncProjectSettingsServiceDeskExternalLinks;
